<template>
  <div class="wrapper">
    <p class="mainContainer__mainTitle mainContainer__mainTitle--mod01">
      {{ $t("mainContainer.getInstantQuote") }}
    </p>

    <div class="navigation navigation--mod1">
      <router-link class="navigation__link navigation__link--active navigation__link--done" to="/"
        style="pointer-events: none !important">
        <span><i class="ri-check-fill"></i></span>
        {{ $t("mainContainer.stepOne") }}
      </router-link>
      <router-link class="navigation__link navigation__link--active navigation__link--done" to="/quote"
        style="pointer-events: none !important">
        <span><i class="ri-check-fill"></i></span>
        {{ $t("mainContainer.stepTwo") }}
      </router-link>
      <router-link class="navigation__link navigation__link--active navigation__link--done" to="/quote/additional"
        style="pointer-events: none !important">
        <span><i class="ri-check-fill"></i></span>
        {{ $t("mainContainer.stepThree") }}
      </router-link>
      <router-link class="navigation__link navigation__link--active navigation__link--done" to="/quote/get-your-quote"
        style="pointer-events: none !important">
        <span><i class="ri-check-fill"></i></span>
        {{ $t("mainContainer.stepFour") }}
      </router-link>
      <router-link class="navigation__link navigation__link--active navigation__link--done" to="/"
        style="pointer-events: none !important">
        <span><i class="ri-check-fill"></i></span>
        {{ $t("mainContainer.stepFive") }}
      </router-link>
    </div>

    <p class="mainContainer__mainTitle mainContainer__mainTitle--mod01 mainContainer__mainTitle--mod02">
      {{ $t("mainContainer.bestPriceAndService") }}
    </p>

    <div id="quoteContainer" class="mainContainer">
      <div class="mainContainer__box mainContainer__box--mod04 mainContainer__box--mod03">
        <div class="mainContainer__price" style="padding-top: 15%">
          <div class="mainContainer__priceItem mainContainer__priceItem--mod1">
            <img src="@/assets/img/green-line.svg" alt="Top line" class="mainContainer__priceItemLine" />

            <div class="mainContainer__priority">
              <p class="mainContainer__priorityText1">
                {{ $t("mainContainer.extended") }}
              </p>
              <p class="mainContainer__priorityText2">
                {{ $t("mainContainer.fiveToTenDaysPickUp") }}
              </p>
            </div>

            <p class="mainContainer__totalPrice">
              $ {{ store.state.finalData.oneToTenDaysPrice }}
            </p>

            <div class="mainContainer__booknow">
              <button class="mainContainer__booknowButton" @click="bookNow('extended')">
                {{ $t("mainContainer.bookNowButtonExtended") }}
              </button>

              <ul class="mainContainer__booknowList">
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.doorToDoor") }}
                </li>
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.makePayment") }}
                </li>
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.insured") }}
                </li>
                <li class="mainContainer__booknowListItem">
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.discount") }}
                </li>
              </ul>
            </div>
          </div>

          <div class="mainContainer__priceItem mainContainer__priceItem--mod2">
            <img src="@/assets/img/blue-line.svg" alt="Top line" class="mainContainer__priceItemLine" />

            <div class="mainContainer__priority">
              <p class="mainContainer__priorityText1">
                {{ $t("mainContainer.standard") }}
              </p>
              <p class="mainContainer__priorityText2">
                {{ $t("mainContainer.threeToFiveDaysPickUp") }}
              </p>
            </div>

            <p class="mainContainer__totalPrice">
              $ {{ store.state.finalData.oneToFiveDaysPrice }}
            </p>

            <div class="mainContainer__booknow">
              <button class="mainContainer__booknowButton" @click="bookNow('standard')">
                {{ $t("mainContainer.bookNowButtonStandard") }}
              </button>
              <ul class="mainContainer__booknowList">
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.doorToDoor") }}
                </li>
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.makePayment") }}
                </li>
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.insured") }}
                </li>
                <li class="mainContainer__booknowListItem">
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.discount") }}
                </li>
              </ul>
            </div>
          </div>

          <div class="mainContainer__priceItem mainContainer__priceItem--mod3">
            <img src="@/assets/img/red-line.svg" alt="Top line" class="mainContainer__priceItemLine" />

            <div class="mainContainer__priority">
              <p class="mainContainer__priorityText1">
                {{ $t("mainContainer.urgent") }}
              </p>
              <p class="mainContainer__priorityText2">
                {{ $t("mainContainer.oneToThreeDaysPickUp") }}
              </p>
            </div>

            <p class="mainContainer__totalPrice">
              $ {{ store.state.finalData.oneToThreeDaysPrice }}
            </p>

            <div class="mainContainer__booknow">
              <button class="mainContainer__booknowButton" @click="bookNow('urgent')">
                {{ $t("mainContainer.bookNowButton") }}
              </button>
              <ul class="mainContainer__booknowList">
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.doorToDoor") }}
                </li>
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.makePayment") }}
                </li>
                <li>
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.insured") }}
                </li>
                <li class="mainContainer__booknowListItem">
                  <img src="@/assets/img/check.png" alt="Check" />
                  {{ $t("mainContainer.discount") }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p class="mainContainer__endTitle">{{ $t('mainContainer.sendQuoteToEmail') }}</p>

        <div class="mainContainer__emailFormContainer">
          <form ref="emailForm" class="mainContainer__emailForm" @submit.prevent="sendEmail">
            <input class="emailForm__email" type="email" :placeholder="$t('mainContainer.enterEmailPlaceholder')">
            <button id="sendQuoteButton" class="emailForm__submit" type="submit">{{ $t('mainContainer.sendQuoteButton')
              }}</button>
          </form>
        </div>

        <p class="mainContainer__alertTextLoading" v-if="emailLoading">{{ $t('mainContainer.sending') }}</p>
        <p class="mainContainer__alertText" v-if="emailSend">{{ $t('mainContainer.emailSentSuccessfully') }}</p>
        <p class="mainContainer__alertTextError" v-if="emailError">{{ $t('mainContainer.emailError') }}</p>

        <p class="mainContainer__endSubtitle" style="margin-top: 30px">
          {{ $t("mainContainer.bookWithAgent") }}
        </p>

        <a href="tel:8706001993" target="_blank" class="mainContainer__endPhone">{{ $t("mainContainer.phone") }}</a>
      </div>

      <div class="mainContainer__box mainContainer__box--mod04 mainContainer__box--mod03">
        <div class="mainContainer__informationalBox mainContainer__informationalBox--mod01">
          <p class="infoSection__title infoSection__title--mod01">
            {{ $t("route_information") }}
          </p>

          <div class="informationalBox__infoSection informationalBox__infoSection--mod01">
            <div class="infoSection__container infoSection__container--33">
              <p class="infoSection__title">{{ $t("from") }}</p>
              <p class="infoSection__select" id="selectFrom">
                {{ store.state.routeData.fromAddress || "-" }}
              </p>
            </div>
            <div class="infoSection__container infoSection__container--33 infoSection__container--flex">
              <div class="infoSection__line"></div>
              <div class="infoSection__miles" id="distanceMiles">
                {{ store.state.routeData.distanceFromTo + " MI" }}
              </div>
              <div class="infoSection__line"></div>
            </div>
            <div class="infoSection__container infoSection__container--33">
              <p class="infoSection__title infoSection__textAlignRight">
                {{ $t("to") }}
              </p>
              <p class="infoSection__select infoSection__textAlignRight" id="selectTo">
                {{ store.state.routeData.toAddress || "-" }}
              </p>
            </div>
          </div>

          <div class="informationalBox__infoSection">
            <div class="infoSection__container">
              <p class="infoSection__title">{{ $t("pickupdate") }}</p>
              <p class="infoSection__select">
                {{ store.state.routeData.pickupDate || "-" }}
              </p>
            </div>
            <div class="infoSection__container">
              <p class="infoSection__title">{{ $t("how_many_veh") }}</p>
              <p class="infoSection__select">
                {{ store.state.routeData.numberOfVehicles || "-" }}
              </p>
            </div>
          </div>

          <div class="informationalBox__infoSection">
            <div class="infoSection__container">
              <p class="infoSection__title" v-if="$store.state.routeData.numberOfVehicles == 1">
                {{ $t("transported_vehicule") }}
              </p>
              <p class="infoSection__title" v-if="$store.state.routeData.numberOfVehicles > 1">
                {{ $t("transported_vehicules") }}
              </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles == 1">
                {{ $store.state.vehicleData.vehicleType || "-" }}
              </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 1">
                1. {{ $store.state.vehicleData.vehicleType || "-" }}
              </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 1">
                2. {{ $store.state.vehicleData.vehicleType_2 || "-" }}
              </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 2">
                3. {{ $store.state.vehicleData.vehicleType_3 || "-" }}
              </p>
              <p class="infoSection__select" v-if="$store.state.routeData.numberOfVehicles > 3">
                4. {{ $store.state.vehicleData.vehicleType_4 || "-" }}
              </p>
            </div>
          </div>

          <div class="informationalBox__infoSection informationalBox__infoSection--mod02">
            <p class="infoSection__title infoSection__title--mod02" v-if="$store.state.routeData.numberOfVehicles == 1">
              {{ $t("aditional_services") }}
            </p>
            <p class="infoSection__title infoSection__title--mod02" v-if="$store.state.routeData.numberOfVehicles > 1">
              {{ $t("aditional_first_veh") }}
            </p>

            <div class="informationalBox__infoSection informationalBox__infoSection--mod03">
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03">
                  {{ $t("runAndDrive") }}
                </p>
                <p class="infoSection__select">
                  {{ $store.state.additionalData.vehicleCondition || "-" }}
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                  {{ $t("personalObjects") }}
                </p>
                <p class="infoSection__select infoSection__textAlignCenter">
                  {{ $store.state.additionalData.vehiclePounds || "-" }} LB
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                  {{ $t("truck_Type") }}
                </p>
                <p class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                  {{ $store.state.additionalData.vehicleType || "-" }}
                </p>
              </div>
            </div>

            <p class="infoSection__title infoSection__title--mod02" v-if="$store.state.routeData.numberOfVehicles > 1">
              {{ $t("aditional_second_veh") }}
            </p>

            <div class="informationalBox__infoSection informationalBox__infoSection--mod03"
              v-if="$store.state.routeData.numberOfVehicles > 1">
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03">
                  {{ $t("runAndDrive") }}
                </p>
                <p class="infoSection__select">
                  {{ $store.state.additionalData.vehicleCondition_2 || "-" }}
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                  {{ $t("personalObjects") }}
                </p>
                <p class="infoSection__select infoSection__textAlignCenter">
                  {{ $store.state.additionalData.vehiclePounds_2 || "-" }} LB
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                  {{ $t("truck_Type") }}
                </p>
                <p class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                  {{ $store.state.additionalData.vehicleType_2 || "-" }}
                </p>
              </div>
            </div>

            <p class="infoSection__title infoSection__title--mod02" v-if="$store.state.routeData.numberOfVehicles > 2">
              {{ $t("aditional_third_veh") }}
            </p>

            <div class="informationalBox__infoSection informationalBox__infoSection--mod03"
              v-if="$store.state.routeData.numberOfVehicles > 2">
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03">
                  {{ $t("runAndDrive") }}
                </p>
                <p class="infoSection__select">
                  {{ $store.state.additionalData.vehicleCondition_3 || "-" }}
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                  {{ $t("personalObjects") }}
                </p>
                <p class="infoSection__select infoSection__textAlignCenter">
                  {{ $store.state.additionalData.vehiclePounds_3 || "-" }} LB
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                  {{ $t("truck_Type") }}
                </p>
                <p class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                  {{ $store.state.additionalData.vehicleType_3 || "-" }}
                </p>
              </div>
            </div>

            <p class="infoSection__title infoSection__title--mod02" v-if="$store.state.routeData.numberOfVehicles > 3">
              {{ $t("aditional_fourth_veh") }}
            </p>

            <div class="informationalBox__infoSection informationalBox__infoSection--mod03"
              v-if="$store.state.routeData.numberOfVehicles > 3">
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03">
                  {{ $t("runAndDrive") }}
                </p>
                <p class="infoSection__select">
                  {{ $store.state.additionalData.vehicleCondition_4 || "-" }}
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                  {{ $t("personalObjects") }}
                </p>
                <p class="infoSection__select infoSection__textAlignCenter">
                  {{ $store.state.additionalData.vehiclePounds_4 || "-" }} LB
                </p>
              </div>
              <div class="infoSection__container infoSection__container--33">
                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                  {{ $t("truck_Type") }}
                </p>
                <p class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                  {{ $store.state.additionalData.vehicleType_4 || "-" }}
                </p>
              </div>
            </div>
          </div>

          <div class="informationalBox__infoSection">
            <div class="infoSection__container">
              <p class="infoSection__title infoSection__title--mod4">
                <span>$ {{ store.state.finalData.totalPriceWithoutDiscount }}
                </span>
                $50 discount
              </p>
              <p class="infoSection__select infoSection__select--mod1">
                $ {{ store.state.finalData.totalPrice }}
              </p>
            </div>
          </div>

          <!-- <div class="formContainer__submitBox formContainer__submitBox--custom02">
            <button class="formContainer__submit formContainer__submit--custom01" v-on:click="backAction">Back</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";

import store from "./../../store";

const { locale } = useI18n();

const router = useRouter();

const emailSend = ref(false);
const emailError = ref(false);
const emailLoading = ref(false);

async function sendEmail(event) {
  const vehicleData = () => {
    let data = [
      {
        vehicle: store.state.vehicleData.vehicleType,
        vehicleCondition: store.state.additionalData.vehicleCondition,
        vehiclePounds: store.state.additionalData.vehiclePounds,
        vehicleType: store.state.additionalData.vehicleType
      },
      {
        vehicle: store.state.vehicleData.vehicleType_2,
        vehicleCondition: store.state.additionalData.vehicleCondition_2,
        vehiclePounds: store.state.additionalData.vehiclePounds_2,
        vehicleType: store.state.additionalData.vehicleType_2
      },
      {
        vehicle: store.state.vehicleData.vehicleType_3,
        vehicleCondition: store.state.additionalData.vehicleCondition_3,
        vehiclePounds: store.state.additionalData.vehiclePounds_3,
        vehicleType: store.state.additionalData.vehicleType_3
      },
      {
        vehicle: store.state.vehicleData.vehicleType_4,
        vehicleCondition: store.state.additionalData.vehicleCondition_4,
        vehiclePounds: store.state.additionalData.vehiclePounds_4,
        vehicleType: store.state.additionalData.vehicleType_4
      }
    ];
    let numberVehicles = store.state.routeData.numberOfVehicles;
    if (!numberVehicles > 1) {
      return [];
    }
    let response = [];
    for (let i = 0; i < numberVehicles; i++) {
      response.push(data[i]);
    }
    return response;
  }
  const email_body = {
    lang: locale,
    to: event.target[0].value,
    routeData: {
      fromAddress: store.state.routeData.fromAddress,
      toAddress: store.state.routeData.toAddress,
      pickupDate: store.state.routeData.pickupDate,
      distanceFromTo: store.state.routeData.distanceFromTo,
    },
    vehicleData: vehicleData(),
    totalPrice: store.state.finalData.totalPrice,
    totalPriceWithoutDiscount: store.state.finalData.totalPriceWithoutDiscount,
  }

  document.querySelector("#sendQuoteButton").setAttribute("disabled", "");

  if (event.target[0].value.length >= 1) {
    const self = this;
    self.emailSend = false;
    self.emailLoading = true;
    console.log(JSON.stringify(store));

    axios.post("https://ratesautotransport.com/api/email/quote",
      email_body
    ).then((message) => {
      document
        .querySelector("#sendQuoteButton")
        .removeAttribute("disabled");
      event.target.reset();
      self.emailLoading = false;
      self.emailSend = true;
    });
  }
}

function backAction() {
  router.push({ name: "GetYourQuote" });
}

function bookNow(string) {
  document
    .querySelectorAll(".mainContainer__booknowButton")
    .forEach((item) => {
      item.setAttribute("disabled", "");
    });

  store.dispatch("SAVE_RESERVATION_TYPE_ACTION", string);

  axios
    .post("https://ratesautotransport.com/api/update_booking", {
      document_id: store.state.documentId,
      data: {
        ...store.state,
      },
    })
    .then((response) => {
      router.push(`/checkout/${store.state.documentId}`);
    })
    .catch((er) => {
      console.log(er);
    });
}

onMounted(async () => {
  await sendMessage();
});

async function sendMessage() {

  const body = {
    name: store.state.message_info.name,
    to: '' + store.state.message_info.phone,
    type: 'quote',
    lang: locale.value,
    price: store.state.finalData.totalPrice
  }

  // const isWhatsapp = store.state.message_info.whatsapp ?? false;
  // const isSms = store.state.message_info.sms ?? false
  const consent_term_privacy_check_box = store.state.message_info.consent ?? false;

  if (!consent_term_privacy_check_box) {
    console.log('No consent for terms and privacy');
    return;
  }

  await axios.post('https://ratesautotransport.com/api/sms', body)
    .catch((error) => {
      console.log(error);
    })
}

</script>